import { render, staticRenderFns } from "./BucketHeader.vue?vue&type=template&id=4b9e689b&"
import script from "./BucketHeader.vue?vue&type=script&lang=js&"
export * from "./BucketHeader.vue?vue&type=script&lang=js&"
import style0 from "./BucketHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports